import { useGlobalModalsContext } from 'contexts/globalModalsContext';

import TrackedMenuItem from '../TrackedMenuItem';

const OpenDiagramMenuItem: React.FC = () => {
  const { openOpenDiagramModal } = useGlobalModalsContext();
  return (
    <TrackedMenuItem value="open-diagram" onClick={openOpenDiagramModal}>
      Open
    </TrackedMenuItem>
  );
};

export default OpenDiagramMenuItem;
